import PropTypes from "prop-types";
import React from "react";
import { timeStampFormat, formatTileName } from "../../utils/common";
import PanelSection from "../panel/index";
import SimConnectivityInsights from "../../containers/activationSales/insights/simConnectivityInsights";

function TabPanel(props) {
  const { children, value, index } = props;
  return (
    <>
      {value === index && (
        <div
          className={`${
            props.sectionName === "TOP 5 Retailers" ||
            props.sectionName === "Bottom 5 Retailers" ||
            props.sectionName === "Top 5 Retailers" ||
            props.sectionName === "Bot 5" ||
            props.sectionName === "Bottom 5 MT Chains" ||
            props.sectionName === "Top 5 MT Chains" ||
            props.moduleName === "My Earnings" ||
            props.sectionName === "Bottom 5 Stores" ||
            props.sectionName === "Top 5"
              ? ""
              : "row"
          }`}
        >
          {children}
        </div>
      )}
    </>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// function a11yProps(index) {
//   return {
//     id: `scrollable-auto-tab-${index}`,
//     'aria-controls': `scrollable-auto-tabpanel-${index}`,
//   };
// }

const RenderPanel = (props) => {
  let { tileName, ...other } = props;
  return <PanelSection tileName={tileName} {...other} />;
};

RenderPanel.propTypes = {
  tileName: PropTypes.string,
};

export default function ScrollableTabs(props) {
  //const classes = useStyles();
  const [selectedTab, setSelectedTab] = React.useState(0);
  const {
    sectionHeader,
    tabsDto,
    sortingProperty,
    timeStampArr,
    sortingOrder = "",
    ...other
  } = props;
  const handleChange = (event, newValue) => {
    setSelectedTab(event);
  };

  // function tabv(props) {
  //     // setTabValue(props);
  // }

  function compareValues(sortingProperty, order = "asc") {
    return function keyBasedSorting(a, b) {
      if (
        !a.hasOwnProperty(sortingProperty) ||
        !b.hasOwnProperty(sortingProperty)
      ) {
        return 0;
      }

      const valueA =
        typeof a[sortingProperty] === "string"
          ? a[sortingProperty].toUpperCase()
          : a[sortingProperty];
      const valueB =
        typeof b[sortingProperty] === "string"
          ? b[sortingProperty].toUpperCase()
          : b[sortingProperty];

      let comparison = 0;
      comparison = valueA > valueB ? 1 : -1;

      return order === "desc" ? comparison * -1 : comparison;
    };
  }

  const getSortedData = (data, sortingProperty, sortingOrder) => {
    return data.sort(compareValues(sortingProperty, sortingOrder));
  };

  let ts = "";
  const currSelectedTile = props.tabsDto.filter(
    (tile) => tile.isTileActive === "Y"
  )[selectedTab].tileName;
  if (timeStampArr) {
    ts = timeStampArr.filter((data) => {
      if (data?.tilename?.includes("Stock")) {
        return data?.tilename?.split("-")[1] === currSelectedTile;
      }
      return data.tilename === currSelectedTile;
    });
    ts = timeStampFormat(
      ts && ts[0] && ts[0].tileTimestamp && ts[0].tileTimestamp?.split(".")[0]
    );
  }
  // console.log(timeStampArr,currSelectedTile,ts)

  const sortedTilesDto = getSortedData(tabsDto, sortingProperty, sortingOrder);
  const visibleTiles = sortedTilesDto.filter(
    (tile) =>
      tile.isTileActive === "Y" &&
      tile.tileName.toLowerCase() !== "sim activation jiophone"
  );
  const simJioPhoneData = sortedTilesDto.filter(
    (tile) => tile.tileName === "SIM Activation JioPhone"
  );

  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
      data-cy={props?.section?.replace(/ /g, "-")}
    >
      <div className="subtitlebox">
        <div className="subtitleboxChild">{props.sectionHeader}</div>
        {/* <div>{ts}</div> */}
      </div>

      {
        // props.sectionHeader.toLowerCase() !== "activation"
        // &&
        props.sectionHeader.toLowerCase() !== "Work Flow Details" ? (
          // &&
          // props.sectionHeader.toLowerCase() !== "recharge"
          <div className="col-md-12 px-0">
            <ul className="nav nav-pills tabbtndiv text-center">
              {props.tabsDto
                .filter(
                  (tile) =>
                    tile.isTileActive === "Y" &&
                    tile.tileName.toLowerCase() !== "sim activation jiophone"
                )
                .map((tile, index) => {
                  return tile.isTileActive === "Y" ? (
                    <li key={index}>
                      <a
                        data-toggle="pill"
                        onClick={() => {
                          handleChange(index, tile);
                        }}
                        href={`#${index}`}
                        className={selectedTab === index ? "active" : ""}
                      >
                        {formatTileName(tile.tileName)}
                      </a>
                    </li>
                  ) : null;
                })}
            </ul>
          </div>
        ) : null
      }

      <div className="tab-content">
        <div id={`#${selectedTab}`} className="tab-pane fade in active">
          <div className="tabcontbox">
            {sortedTilesDto
              .filter((tile) => tile.isTileActive === "Y")
              .map((tile, index) => {
                return (
                  <TabPanel
                    key={tile.tileId}
                    value={selectedTab}
                    index={index}
                    sectionName={tile.tileName}
                    moduleName={props.moduleName}
                    data-cy="tab-panel"
                  >
                    <RenderPanel
                      url={tile.tileEndPointUrl}
                      csvEndPointUrl={tile.csvEndPointUrl}
                      isCsvActive={tile.isCsvActive}
                      change={props.change}
                      tileName={tile.tileName}
                      tileCode={tile.tileCode}
                      sectionName={sectionHeader}
                      simJioPhoneData={
                        tile?.tileName?.toLowerCase() === "sim activation"
                          ? simJioPhoneData?.[0]
                          : null
                      }
                      {...other}
                    />
                  </TabPanel>
                );
              })}
          </div>
        </div>
      </div>
      {sectionHeader === "MDN Sim Connectivity" ? (
        <SimConnectivityInsights
          selectedTab={selectedTab}
          visibleTiles={visibleTiles}
          filterValue={props.filterValue}
          moduleName={props.moduleName}
        />
      ) : null}
      <div className="card-timestamp border-top mt-2" data-cy="timestamp">
        <i className="fa fa-history mr-2 mt-2 mb-0"></i>
        Updated on {ts}
      </div>
    </div>
  );
}
